import arrowIcon from '../../assets/icons/DashboardIcons/arrow.svg';
import Button from '../global/Button';

type QuickSetupCardProps = {
  icon: string;
  title: string;
  desc: string;
  btnText: string;
  className?: string;
};

const QuickSetupCard = ({ title, desc, btnText, icon }: QuickSetupCardProps) => {
  return (
    <div
      style={{
        borderRadius: '20px',
        border: '0.2px solid rgba(248, 180, 0, 0.3)',
        boxShadow: '0px 16.52px 30px rgba(118, 131, 150, 0.09)',
      }}
      className='w-[300px] py-4 pl-4 pb-3 pr-[70px]'
    >
      <div className=''>
        <div className='mb-[15px]'>
          <img src={icon} className='w-8 items-start ' alt='payment-link' />
        </div>
        <div>
          <h1
            style={{ lineHeight: '16.5px', fontWeight: 600 }}
            className='text-[15px] font-poppins text-green '
          >
            {title}
          </h1>
          <p
            style={{
              fontFamily: 'DM Sans',
              fontSize: '13px',
              lineHeight: '15px',
              letterSpacing: '0em',
              color: '#000000',
            }}
            className='text-xs font-medium py-3'
          >
            {desc}
          </p>
        </div>
      </div>
      {/* <div className='border-b-[0.3px] md:block  border-[#666666]'></div> */}
      <div
        style={{
          fontFamily: 'DM Sans',
          fontSize: '17px',
          fontWeight: 400,
          lineHeight: '15px',
          letterSpacing: '0em',
        }}
        className='flex text-center'
      >
        <Button
          className='mt-3 bg-[#028789] brightness-[80%] text-white p-[10px] text-xs rounded cursor-not-allowed'
          underline={false}
          disabled={true}
          tag='aa'
        >
          {btnText}
        </Button>
      </div>
    </div>
  );
};

export default QuickSetupCard;
